import { Injectable } from '@angular/core';
import { CustomProductSearchPage, RangeFacet } from '@catalog/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CustomOccProductSearchPageNormalizer implements Converter<
  CustomProductSearchPage,
  Partial<CustomProductSearchPage>
> {
  convert(source: CustomProductSearchPage, target?: CustomProductSearchPage): Partial<CustomProductSearchPage> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (target.facets) {
      const facets = target.facets.map((facet) => {
        const personalPriceFacet = facet as RangeFacet;
        const { maxValue, minValue, code } = personalPriceFacet;
        if (code === 'personalPrice' && maxValue && minValue) {
          const fixedMinValue = Math.round(parseFloat(minValue as any) * 1e2) / 1e2;
          const fixedMaxValue = Math.round(parseFloat(maxValue as any) * 1e2) / 1e2;

          return { ...personalPriceFacet, minValue: fixedMinValue, maxValue: fixedMaxValue };
        }

        return personalPriceFacet;
      });

      return { ...target, facets };
    }

    return target;
  }
}
